import React, { useContext, useEffect, useState } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
import { updateEvents } from 'gqlQueries/promoRecommendation';
import { notification } from 'antd';
import { FilterContextData } from 'contexts/FilterContext';

const errorMessage: string = 'Something went wrong!';

function useUpdatePlan(fetchEventsList: any, selectedPlan: any, onComplete = () => {}, triggerNotification = false) {
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>([]);
    const [editType, setEditType] = useState('add');
    const { currentFrequency } = useContext(FilterContextData);
    //To fetch dim
    const [updateEventFunction, { data: EventResponse, loading: EventResponseLoading, error: EventResponseError }] =
        useMutation(updateEvents, {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        });

    useEffect(() => {
        setLoading(EventResponseLoading);
    }, [EventResponseLoading]);

    const openNotification = (message: any) => {
        notification.open({
            message: message,
            className: 'custom-class',
            style: {
                width: 300,
                height: 70,
            },
        });
    };

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            setData(() => payload);
            onComplete();
            if (triggerNotification) {
                openNotification(`Event Successfully ${editType === 'add' ? 'Added' : 'Modified'}`);
            }
            fetchEventsList({
                variables: {
                    planId: selectedPlan?.planId,
                    frequency: currentFrequency?.key,
                },
            });
        } catch (error) {
            console.error(errorMessage, error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        //sending empty data to error to avoid null data being sent
        setData([]);
        setLoading(false);
        setError(error);
        openNotification('Something went wrong!');
    }

    return {
        loading,
        error,
        data,
        updateEventFunction: (variables: any) => {
            updateEventFunction(variables);
            setEditType(variables.variables.operationType);
        },
        onFetchComplete,
    };
}

export default useUpdatePlan;
